import { CartProduct } from '~/src/common/typings/cart';
import { isTruthy } from '~/src/common/utils/guards';
import { RecipeIngredientProduct } from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/types';

// Cette fonction ne doit pas être utilisé dans le render d'un composant car si les
// données qu'il produit sont utilisées comme props d'un composant, le composant ne sera
// pas réactif si les ingrédients changent
const getAvailableArticlesFromIngredients = (
  ings: RecipeIngredientProduct[],
  cartProducts: CartProduct[],
) => {
  return ings
    .map(i => i.article)
    .filter(isTruthy)
    .filter(a => {
      if (a.enabled === false) return false;

      const cartQuantity = cartProducts.find(p => p.id === a.id)?.quotation2.count.quantity ?? 0;
      const remainingQuantity = a.availableQuantity - cartQuantity;
      const isAvailable = remainingQuantity >= a.quantity;

      return isAvailable;
    });
};

export default getAvailableArticlesFromIngredients;
